__turbopack_context__.v({
  "badge": "styles-module-scss-module__VKnOZG__badge",
  "favButton": "styles-module-scss-module__VKnOZG__favButton",
  "iconWrap": "styles-module-scss-module__VKnOZG__iconWrap",
});
